import { useState } from 'react'
import Talk from './Talk'
import { useTrainerToken } from '../lib/trainerToken'

export default function TextChat() {
  const [train, setTrain] = useState(false)
  const { token, setToken } = useTrainerToken()

  return (
    <div className="text-page">
      <Talk
        key={train ? 'train' : 'chat'}
        mode={train ? 'trainer' : 'text'}
        trainerToken={token}
        toolbarLeading={
          <div className="chat-mode" role="tablist" aria-label="Text chat mode">
            <button type="button" role="tab" aria-selected={!train} onClick={() => setTrain(false)}>
              Chat
            </button>
            <button type="button" role="tab" aria-selected={train} onClick={() => setTrain(true)} data-testid="text-train-mode">
              Train
            </button>
            {train && (
              <label className="chat-mode-token">
                <span>Trainer token</span>
                <input
                  type="password"
                  autoComplete="off"
                  value={token}
                  onChange={(event) => setToken(event.target.value)}
                  placeholder="Kept in memory only"
                  data-testid="trainer-token"
                />
              </label>
            )}
          </div>
        }
        toolbarNote={
          train ? (
            <p className="chat-mode-note">
              This chat trains the agent. Tell it how a step should be handled, and the Trainer page draws the updated call flow.
            </p>
          ) : null
        }
      />
    </div>
  )
}
